export enum ExtraType {
    Button = 1,
    Text = 2,
    ImageLink = 3
}
